// Condo documents: tab keys, defaults and display helpers.

// The Condo Details tab "rules" is `house_rules` in the API.
export const DOC_TYPE_BY_TAB = {
  notice: 'notice',
  mom: 'mom',
  rules: 'house_rules',
};

// Whether a file goes to the bot when the admin has not chosen (the
// server's own default, C37): notices and house rules yes, minutes no.
export const BOT_DEFAULT_BY_TYPE = {
  notice: true,
  mom: false,
  house_rules: true,
};

export const DOC_EXTENSIONS = [
  'pdf',
  'docx',
  'pptx',
  'txt',
  'md',
  'markdown',
  'csv',
  'xlsx',
];
export const DOC_ACCEPT = DOC_EXTENSIONS.map(ext => `.${ext}`).join(',');
export const DOC_MAX_MB = 15;

export const DOC_SORTS = ['newest', 'name_asc', 'name_desc'];

export const DOC_STATUS_STYLE = {
  not_in_bot:
    'bg-slate-100 text-slate-600 dark:bg-slate-600 dark:text-slate-300',
  processing: 'bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-200',
  ready: 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
  failed: 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100',
};

const extensionOf = name => {
  const dot = String(name).lastIndexOf('.');
  return dot < 0
    ? ''
    : String(name)
        .slice(dot + 1)
        .toLowerCase();
};

// Checked in the browser before a file is sent; the server checks again.
// Returns an error code (CO_LIVING.CONDOS.DOCUMENTS.FILE_ERRORS.<CODE>) or ''.
export function documentFileProblem(file) {
  if (!DOC_EXTENSIONS.includes(extensionOf(file.name))) return 'TYPE';
  if (file.size === 0) return 'EMPTY';
  if (file.size > DOC_MAX_MB * 1024 * 1024) return 'SIZE';
  return '';
}

// "110 B", "2.4 KB", "1.5 MB".
export function formatBytes(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Rows still being read by the knowledge service: these are polled.
export const processingIds = items =>
  items.filter(item => item.status === 'processing').map(item => item.id);
